import classes from "./About.module.css";
import pp from "../assets/img/pp.jpg";
import TypeAnimation from "react-type-animation";
import { useInView } from "react-intersection-observer";
import { useEffect, useState } from "react";

const About = () => {
  const [isVisible, setIsVisible] = useState(false);

  const { ref, inView } = useInView({
    rootMargin: "30px",
    threshold: 0.01,
    triggerOnce: true,
  });

  useEffect(() => {
    setIsVisible(inView);
  }, []);

  return (
    <div className="about">
      <div className={classes.about}>
        <div
          className={`${classes.profile} ${
            inView ? classes["profile-active"] : " "
          }`}
          ref={ref}
        >
          <img src={pp} alt="Abhishek Chamoli"/>
        </div>
        <div className={classes.intro}>
          <h2>
            About
            <TypeAnimation
              cursor={true}
              sequence={[" Me", 5000, ""]}
              repeat={Infinity}
              wrapper="span"
            />
          </h2>
          <p>
            I am a Full Stack Web Application Developer with a vast array of
            knowledge in many different front end and back end languages,
            responsive frameworks, databases, and best code practices. My
            objective is simply to be the best web application developer that I
            can be and to contribute to the technology industry all that I know
            and can do. I have a great knowledge of modern Web Technologies like
            HTML5, CSS3, Javascript, React js, Node js, Express js, MongoDB, My
            SQL etc.... I also have a good hand in writing clean, reusable &
            readable code.
          </p>

          <div className={classes.socials}>
            <a
              herf="https://github.com/AbhishekChamoliDeveloper"
              target="_blank"
            >
              <i class="fab fa-github"></i>
            </a>
            <a
              herf="https://www.linkedin.com/in/abhishek-chamoli/"
              target="_blank"
            >
              <i class="fab fa-linkedin"></i>
            </a>
            <a herf="https://www.instagram.com/abhishekchamoli_official/?hl=en">
              <i class="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
